<template>
  <!--  App.vue是项目的主组件，页面入口文件 ，所有页面都在App.vue下进行切换，app.vue负责构建定义及页面组件归集-->
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;

}

html,
body,
#app {
  min-width: 1300px;
  height: 100%;
  overflow: hidden;
}</style>



// WEBPACK FOOTER //
// src/App.vue